import { useInfiniteQuery } from "@tanstack/react-query";

import { searchUsers } from "../services/users.service";
import { UserSearch } from "../types/users.types";

export const useUserSearch = (params: UserSearch.Request) => {
  const { enableInitialSearch = false, ...searchParams } = params;

  return useInfiniteQuery<UserSearch.Response>({
    queryKey: ["users", "search", params],
    queryFn: ({ pageParam = 0 }) =>
      searchUsers({
        ...searchParams,
        offset: pageParam as number,
      }),
    getNextPageParam: (lastPage) => {
      const { currentPage, totalPages } = lastPage.meta;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    initialPageParam: 0,
    enabled: enableInitialSearch ? true : !!params.searchValue && params.searchValue.length >= 2,
    staleTime: 1000 * 60 * 1,
  });
};
